import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { ACTIVE_COLOR } from '../../utils/constants';
import { capitalizeFirstLetter } from "../../utils/utils";

const useStyles = makeStyles(theme => ({
    primary: {
        fontSize: 18,
        marginBottom: theme.spacing(0.5)
    },
    secondary: {
        fontSize: 11,
        textTransform: 'uppercase',
        fontWeight: 700
    },
    primaryLight: {
        fontWeight: 500,
        color: '#fff'
    },
    primaryDark: {
        fontWeight: 700,
        color: '#112435'
    },
    secondaryLight: {
        color: ACTIVE_COLOR,
    }
}));

const Topic = ({ name, category, theme }) => {
    const classes = useStyles();

    return (
        <Box display="flex" flexDirection="column">
            <Typography className={clsx(
                theme? classes.primaryLight: classes.primaryDark, 
                classes.primary)}
            >
                    {name? capitalizeFirstLetter(name): ''}
            </Typography>
            {category && <Typography className={clsx(classes.secondaryLight, classes.secondary)}>{category}</Typography>}
        </Box>
    )
}

export default Topic;
